import { render, staticRenderFns } from "./PopupFilter.vue?vue&type=template&id=4bfbcbea&scoped=true&"
import script from "./PopupFilter.vue?vue&type=script&lang=js&"
export * from "./PopupFilter.vue?vue&type=script&lang=js&"
import style0 from "./PopupFilter.vue?vue&type=style&index=0&id=4bfbcbea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbcbea",
  null
  
)

export default component.exports